export default {
  allMaintenances: [],
  maintenance: {},
}
